const heroSliderItems = [
  { id: 0, image: '/images/team/collage/01.webp', altText: 'Our team' },
  { id: 1, image: '/images/team/collage/2.webp', altText: 'Our team' },
  { id: 2, image: '/images/team/collage/3.webp', altText: 'Our team' },
  { id: 3, image: '/images/team/collage/4.webp', altText: 'Our team' },
  { id: 4, image: '/images/team/collage/5.webp', altText: 'Our team' },
  { id: 5, image: '/images/team/collage/6.webp', altText: 'Our team' },
  { id: 6, image: '/images/team/collage/7.webp', altText: 'Our team' },
  { id: 7, image: '/images/team/collage/8.webp', altText: 'Our team' },
  { id: 8, image: '/images/team/collage/9.webp', altText: 'Our team' },
  { id: 9, image: '/images/team/collage/010.webp', altText: 'Our team' },
  { id: 10, image: '/images/team/collage/011.webp', altText: 'Our team' },
];

const teamAchievements = {
  UK: [
    {
      id: 0,
      label: '92%',
      description: 'загальна задоволеність компанією як місцем роботи',
    },
    { id: 1, label: '81%', description: 'eNPS' },
    {
      id: 2,
      label: '67%',
      description: 'менеджерів виросли всередині компанії',
    },
    { id: 3, label: '7 років', description: 'середній стаж роботи в компанії' },
  ],
  EN: [
    {
      id: 0,
      label: '92%',
      description:
        'overall employee satisfaction with the company as a workplace',
    },
    { id: 1, label: '81%', description: 'eNPS' },
    {
      id: 2,
      label: '67%',
      description: 'of managers were promoted within the company',
    },
    {
      id: 3,
      label: '7 years',
      description: 'average tenure at the company',
    },
  ],
};

const teamCulture = {
  UK: [
    {
      id: 0,
      label: 'Досягнення',
      description:
        'Нас запалюють виклики і результати, стійкість, енергія, нестримний рух до нового і нових звершень. Ми прагнемо бути швидше, краще і вище, ніж вчора. Ми говоримо "НІ" посередності, ліні та пасивності.',
      icon: '/icons/team/1.svg',
    },
    {
      id: 1,
      label: 'Вдосконалення',
      description:
        'Ми постійно навчаємось і розвиваємось, вдосконалюємо процеси, якість, особисту і командну ефективність.  Ми тримаємо руку на пульсі змін і сучасних підходів. І знаємо, що помилки - це шлях до розвитку, а проблеми - це просто виклики.',
      icon: '/icons/team/2.svg',
    },
    {
      id: 2,
      label: 'Взаємодія',
      description:
        'Особиста відповідальність кожного - це побудова партнерських, win-win відносин. Тож наша командна робота, довіра, повага і доброзичливе ставлення один до одного - їх невід`ємні частини. ',
      icon: '/icons/team/3.svg',
    },
  ],
  EN: [
    {
      id: 0,
      label: 'Achievement',
      description:
        'We are inspired by challenges and results, by resilience, energy, and the unstoppable pursuit of new goals and accomplishments. We strive to be faster, better, and higher than yesterday. We say NO to mediocrity, laziness, and passivity.',
      icon: '/icons/team/1.svg',
    },
    {
      id: 1,
      label: 'Improvement',
      description:
        'We are committed to continuous learning and development, enhancing processes, quality, and both personal and team effectiveness. We keep our finger on the pulse of change and modern approaches. We understand that mistakes are part of growth, and that problems are simply challenges.',
      icon: '/icons/team/2.svg',
    },
    {
      id: 2,
      label: 'Collaboration',
      description:
        'Personal responsibility means building strong, win-win partnerships. That’s why teamwork, trust, respect, and a supportive attitude toward each other are essential to who we are. ',
      icon: '/icons/team/3.svg',
    },
  ],
};

const collageItems = [
  { id: 0, image: '/images/team/collage/01.webp', altText: 'Our team' },
  { id: 1, image: '/images/team/collage/2.webp', altText: 'Our team' },
  { id: 2, image: '/images/team/collage/3.webp', altText: 'Our team' },
  { id: 3, image: '/images/team/collage/4.webp', altText: 'Our team' },
  { id: 4, image: '/images/team/collage/5.webp', altText: 'Our team' },
  { id: 5, image: '/images/team/collage/6.webp', altText: 'Our team' },
  { id: 6, image: '/images/team/collage/7.webp', altText: 'Our team' },
  { id: 7, image: '/images/team/collage/8.webp', altText: 'Our team' },
  { id: 8, image: '/images/team/collage/9.webp', altText: 'Our team' },
  { id: 9, image: '/images/team/collage/010.webp', altText: 'Our team' },
];

const teamAdvantages = {
  UK: [
    {
      id: 0,
      description:
        'Забезпечуємо конкурентний рівень заробітної плати, згідно грейдингової системи компанії.',
      icon: '/icons/team/advantages/1.svg',
    },
    {
      id: 4,
      description:
        'Піклуємось про здоровʼя, тому для всіх співробітників компанії передбачено медичне страхування.',
      icon: '/icons/team/advantages/4.svg',
    },
    {
      id: 2,
      description:
        'Дотримуємось українського законодавства, тому у нас офіційне працевлаштування, оплачувана відпустка та лікарняні (згідно КЗпП України).',
      icon: '/icons/team/advantages/5.svg',
    },
    {
      id: 3,
      description:
        'Втілюємо в життя круті ідеї та проєкти – від першого задуму до реального результату.',
      icon: '/icons/team/advantages/3.svg',
    },
    {
      id: 1,
      description:
        'Підтримуємо вдосконалення та розвиток команди: корпоративна бібліотека, оплачуване навчання, обмін досвідом та проходження сертифікацій.',
      icon: '/icons/team/advantages/2.svg',
    },
    {
      id: 5,
      description:
        'Забезпечуємо мобільним звʼязком та надаємо корпоративне авто.',
      icon: '/icons/team/advantages/6.svg',
    },
  ],
  EN: [
    {
      id: 0,
      description:
        'We offer a competitive salary based on the company’s grading system.',
      icon: '/icons/team/advantages/1.svg',
    },
    {
      id: 1,
      description:
        'We support growth and development: access to a corporate library, funded training, knowledge sharing, and professional certifications.',
      icon: '/icons/team/advantages/2.svg',
    },
    {
      id: 2,
      description:
        'We strictly follow Ukrainian labor law, ensuring official employment, paid vacation, and sick leave (in line with the Labor Code of Ukraine).',
      icon: '/icons/team/advantages/5.svg',
    },
    {
      id: 3,
      description:
        'We bring bold ideas and projects to life — from the very first concept to tangible results.',
      icon: '/icons/team/advantages/3.svg',
    },
    {
      id: 4,
      description:
        'We care about health, which is why all employees are provided with medical insurance.',
      icon: '/icons/team/advantages/4.svg',
    },
    {
      id: 5,
      description: 'We provide mobile communication and a company car.',
      icon: '/icons/team/advantages/6.svg',
    },
  ],
};

const recruitingStages = {
  UK: [
    {
      id: 0,
      description:
        'Резюме (надсилайте своє резюме на одну з відкритих позицій)',
    },
    {
      id: 1,
      description:
        'Скрінінг резюме (рекрутер звʼяжеться з вами, якщо відбудеться job match)',
    },
    {
      id: 2,
      description: 'Тестове завдання (для певних позицій)',
    },
    {
      id: 3,
      description:
        'Співбесіди (кількість зустрічей та склад учасників залежить від позиції)',
    },
    {
      id: 4,
      description: 'Пропозиція про роботу',
    },
    {
      id: 5,
      description: 'Welcome on board!',
    },
  ],
  EN: [
    {
      id: 0,
      description: 'Resume (submit your CV for one of our open positions)',
    },
    {
      id: 1,
      description:
        'Resume screening (a recruiter will contact you if there’s a job match)',
    },
    {
      id: 2,
      description: 'Test assignment (for certain positions)',
    },
    {
      id: 3,
      description:
        'Interviews (the number of meetings and participants depends on the role)',
    },
    {
      id: 4,
      description: 'Job offer',
    },
    {
      id: 5,
      description: 'Welcome on board!',
    },
  ],
};

const shareButtons = [
  {
    id: 0,
    icon: '/icons/team/linkedin.svg',
    link: 'https://www.linkedin.com/',
    title: 'linkedin',
  },
  {
    id: 1,
    icon: '/icons/team/instagram.svg',
    link: 'https://www.instagram.com/',
    title: 'instagram',
  },
  {
    id: 2,
    icon: '/icons/team/facebook.svg',
    link: 'https://www.facebook.com/',
    title: 'facebook',
  },
];

export {
  heroSliderItems,
  teamCulture,
  teamAchievements,
  collageItems,
  teamAdvantages,
  recruitingStages,
  shareButtons,
};
